import React from 'react';
import { Button } from '../ui/button';
import { MessageSquare, X } from 'lucide-react';
import MarkdownContent from './MarkdownContent';

export const TokenLimitDialog = ({ onClose, onNewConversation }) => (
  <div className="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-50">
    <div className="surface-glass-dark rounded-2xl p-8 max-w-sm mx-4 shadow-obsidian">
      <div className="text-center">
        <div className="w-14 h-14 bg-amber-500/10 border border-amber-500/30 rounded-2xl flex items-center justify-center mx-auto mb-5">
          <MessageSquare className="w-7 h-7 text-amber-400" strokeWidth={1.5} />
        </div>
        <h3 className="font-display text-lg font-semibold text-white mb-2 tracking-tight">
          對話已達上限
        </h3>
        <p className="text-obsidian-200 text-sm mb-6 leading-relaxed">
          此對話的內容已達到 Token 上限，無法繼續對話。<br />
          請新建一個對話以繼續使用。
        </p>
        <div className="flex gap-3 justify-center">
          <Button
            variant="outline"
            onClick={onClose}
            className="rounded-full px-5 h-9 text-sm border-obsidian-600 text-obsidian-100 bg-transparent hover:bg-white/5"
          >
            取消
          </Button>
          <Button
            onClick={onNewConversation}
            className="rounded-full px-5 h-9 btn-neon text-sm font-semibold"
          >
            新建對話
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export const UsageGuideModal = ({ agent, onClose }) => (
  <div
    className="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-50"
    onClick={onClose}
  >
    <div
      className="surface-glass-dark rounded-2xl max-w-lg w-full mx-4 shadow-obsidian max-h-[82vh] flex flex-col"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between p-5 border-b border-obsidian-600 flex-shrink-0">
        <div className="flex items-center gap-2.5">
          <span className="text-xl">{agent.icon}</span>
          <div>
            <h3 className="font-display text-base font-semibold text-white tracking-tight">
              {agent.name}
            </h3>
            <p className="label-micro text-obsidian-300">USAGE · GUIDE</p>
          </div>
        </div>
        <button
          onClick={onClose}
          className="w-8 h-8 rounded-md flex items-center justify-center text-obsidian-300 hover:text-white hover:bg-white/5 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-5 text-obsidian-100">
        <MarkdownContent content={agent.usage_guide} />
      </div>
    </div>
  </div>
);
